var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiteActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_9514",
    "data-name": "Grupo 9514",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.857,
    height: 125.099,
    viewBox: "0 0 139.857 125.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4060",
    "data-name": "Trazado 4060",
    d: "M833.529,458.654v.022H819.517V410.425h9.589a8.164,8.164,0,0,0,8.165-8.165V378.294a8.137,8.137,0,0,0-7.315-8.082L789.744,410.43h20.4v48.252H726.608l.006-48.235h-.458l40.34-40.335H753.82l-40.3,40.291h3.7v48.251H703.068a4.7,4.7,0,1,0,0,9.391h130.46a4.7,4.7,0,1,0,0-9.391Z",
    transform: "translate(-698.37 -342.946)",
    fill: "#fbc601"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4061",
    "data-name": "Trazado 4061",
    d: "M725.352,392.357v-3.02a12.531,12.531,0,1,0-9.385,0v3.02h-9.153a8.163,8.163,0,0,0-8.165,8.16v23.971a8.124,8.124,0,0,0,2.876,6.172l38.3-38.3Z",
    transform: "translate(-697.113 -365.191)",
    fill: "#fbc601"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4062",
    "data-name": "Trazado 4062",
    d: "M722.988,432.675l40.324-40.324H765.5v-3a12.528,12.528,0,1,0-9.391,0v3.009h-5.477l-40.318,40.318Z",
    transform: "translate(-644.356 -365.191)",
    fill: "#fbc601"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4063",
    "data-name": "Trazado 4063",
    d: "M718.389,410.43l40.318-40.318H746.032L705.715,410.43Z",
    transform: "translate(-665.167 -342.948)",
    fill: "#fbc601"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4064",
    "data-name": "Trazado 4064",
    d: "M718.846,370.111h0Z",
    transform: "translate(-663.393 -342.949)",
    fill: "#fbc601"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4065",
    "data-name": "Trazado 4065",
    d: "M723.449,370.111h0Z",
    transform: "translate(-642.584 -342.949)",
    fill: "#fbc601"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4066",
    "data-name": "Trazado 4066",
    d: "M728.053,370.111h0Z",
    transform: "translate(-621.774 -342.949)",
    fill: "#fbc601"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteActive);
export default __webpack_public_path__ + "static/media/site_active.16e2b52e9e2137cfad1fdfc7d4d1f1cd.svg";
export { ForwardRef as ReactComponent };